/*
 * Copyright (c) 2022 Well Solutions SRL. All Rights Reserved.
 * This software is the proprietary information of Well Solutions SRL.
 * Use is subject to license and non-disclosure terms
 */

import { AbstractControlValueAccessorControl } from './abstract-control-value-accessor-control';
import { UntypedFormArray } from '@angular/forms';
import { Directive } from '@angular/core';

@Directive()
export abstract class AbstractControlValueAccessorArray extends AbstractControlValueAccessorControl {
  declare form: UntypedFormArray | undefined;

  protected constructor() {
    super();
  }

  writeValue(value: any): void {
    if (Array.isArray(value)) {
      value.forEach(() => this.addControl(value));
      this.form?.patchValue(value, { emitEvent: false });
    }
  }

  protected abstract addControl(value: any): void;
}
